/**
 * teddy-wishlist-btn è un custom element; su iOS/WebKit il tap non sempre genera "click".
 * Touchend globale assicura che il toggle funzioni ovunque (product card, PDP, cart, search).
 * Dopo reload AJAX del cart-form i nodi possono restare non aggiornati: qui si usa TeddyWishlist direttamente.
 */
(function () {
	var SUPPRESS_MS = 500;

	function getItem(btn) {
		var v = btn.getAttribute('data-variant');
		var h = btn.getAttribute('data-handle');
		if (!v || !h) return null;
		return { variant: v, handle: h };
	}

	function syncUi(btn) {
		var item = getItem(btn);
		if (!item || !window.TeddyWishlist) return;
		btn.classList.toggle('active', TeddyWishlist.isInWishlist(item));
	}

	function toggleWishlist(btn) {
		var item = getItem(btn);
		if (!item || !window.TeddyWishlist) return;
		if (TeddyWishlist.isInWishlist(item)) {
			TeddyWishlist.removeItem(item);
		} else {
			TeddyWishlist.addItem(item);
		}
		syncUi(btn);
	}

	document.addEventListener(
		'touchend',
		function (e) {
			var btn = e.target.closest && e.target.closest('teddy-wishlist-btn');
			if (!btn || !e.isTrusted) return;
			if (!window.TeddyWishlist) return;
			btn._wlTouchTs = Date.now();
			e.preventDefault();
			toggleWishlist(btn);
		},
		{ passive: false, capture: true }
	);

	document.addEventListener(
		'click',
		function (e) {
			var btn = e.target.closest && e.target.closest('teddy-wishlist-btn');
			if (!btn) return;
			if (btn._wlTouchTs && Date.now() - btn._wlTouchTs < SUPPRESS_MS) {
				e.stopImmediatePropagation();
				e.preventDefault();
			}
		},
		true
	);

	function scanCart(root) {
		var scope = root && root.querySelectorAll ? root : document;
		scope.querySelectorAll('.cart-item teddy-wishlist-btn').forEach(syncUi);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () {
			scanCart(document);
		});
	} else {
		scanCart(document);
	}

	window.addEventListener('mc:wishlist:changed', function () {
		scanCart(document);
	});
	window.addEventListener('mc:wishlist:added', function () {
		scanCart(document);
	});
	window.addEventListener('mc:wishlist:removed', function () {
		scanCart(document);
	});

	try {
		new MutationObserver(function (muts) {
			muts.forEach(function (m) {
				m.addedNodes.forEach(function (node) {
					if (node.nodeType !== 1) return;
					if (node.matches && node.matches('.cart-item teddy-wishlist-btn')) syncUi(node);
					if (node.querySelectorAll) scanCart(node);
				});
			});
		}).observe(document.documentElement, { childList: true, subtree: true });
	} catch (err) {
		/* ignore */
	}
})();
